<template>
    <li
            @click.stop="_selectOptionClick"
            class="mc-selectbox-pane__item"
            :class="{
      'selected' : false
    }"
    >
        <slot>
            <span>{{currentLabel}}</span>
        </slot>
    </li>
</template>
<script type="text/ecmascript-6">
    import Emitter from '../mixins/emitter'
    export default {
        mixins: [Emitter],
        name: 'base-select-option',
        inject:['select'],
        props: {
            value: {
                required: true
            },
//            created: Boolean,
            label: [String, Number],
            index: [String, Number],
            item: [Object, String, Number]
        },

        data() {
            return {


            }
        },

        computed: {
            currentLabel(){
                return this.label || this.value || ''
            },
            currentValue() {
                return this.value || this.label || '';
            },


        },
        watch: {

        },
        methods: {
            _selectOptionClick(){
                this.dispatch('base-select', 'handleOptionClick', this);
            }

        },
        created(){
            this.select.options.push(this);
            this.select.cachedOptions.push(this);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/base-selectbox-item.vue